<svg *ngIf="icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" version="1.1"
	xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" [attr.viewBox]="viewbox"
	[attr.height]="size" [attr.width]="size" [ngStyle]="{'width': this.size, 'height': this.size}">
	<title *ngIf="title">{{ title }}</title>
	<g [attr.transform]="transform" [innerHTML]="paths"></g>
</svg>
